import { SupportBoard } from '@/shell/services/support'

export function SupportPage() {
  return <SupportBoard />
}
